import { CashAddressNetworkPrefix } from "@bitauth/libauth";
export var NetworkType;
(function (NetworkType) {
    NetworkType["Mainnet"] = "mainnet";
    NetworkType["Testnet"] = "testnet";
    NetworkType["Regtest"] = "regtest";
})(NetworkType || (NetworkType = {}));
export var NetworkEnum;
(function (NetworkEnum) {
    NetworkEnum[NetworkEnum["Mainnet"] = "mainnet"] = "Mainnet";
    NetworkEnum[NetworkEnum["Testnet"] = "testnet"] = "Testnet";
    NetworkEnum[NetworkEnum["Regtest"] = "regtest"] = "Regtest";
    NetworkEnum[NetworkEnum["Simtest"] = "simtest"] = "Simtest";
})(NetworkEnum || (NetworkEnum = {}));
export const networkPrefixMap = {
    bitcoincash: "mainnet",
    bchtest: "testnet",
    bchreg: "regtest",
};
export const prefixFromNetworkMap = {
    mainnet: CashAddressNetworkPrefix.mainnet,
    testnet: CashAddressNetworkPrefix.testnet,
    regtest: CashAddressNetworkPrefix.regtest,
};
const literal = (l) => l;
export const UnitEnum = {
    BCH: literal("bch"),
    USD: literal("usd"),
    BIT: literal("bit"),
    BITS: literal("bits"),
    SAT: literal("sat"),
    SATS: literal("sats"),
    SATOSHI: literal("satoshi"),
    SATOSHIS: literal("satoshis"),
};
//# sourceMappingURL=enum.js.map